import { render, staticRenderFns } from "./shopsgoods-add-or-update.vue?vue&type=template&id=72cec59b&"
import script from "./shopsgoods-add-or-update.vue?vue&type=script&lang=js&"
export * from "./shopsgoods-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports